import { pl } from "./pl";

export const localization = {
  pl: pl,
};
